
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 28","data-code":"61805","data-tags":"instagram"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 14c0-2.203-1.797-4-4-4s-4 1.797-4 4 1.797 4 4 4 4-1.797 4-4zm2.156 0c0 3.406-2.75 6.156-6.156 6.156S5.844 17.406 5.844 14 8.594 7.844 12 7.844s6.156 2.75 6.156 6.156zm1.688-6.406c0 .797-.64 1.437-1.438 1.437s-1.437-.64-1.437-1.437.64-1.438 1.437-1.438 1.438.64 1.438 1.438zM12 4.156c-1.75 0-5.5-.14-7.078.485-.547.218-.953.484-1.375.906s-.688.828-.906 1.375C2.016 8.5 2.156 12.25 2.156 14s-.14 5.5.485 7.078c.218.547.484.953.906 1.375s.828.688 1.375.906c1.578.625 5.328.485 7.078.485s5.5.14 7.078-.485c.547-.218.953-.484 1.375-.906s.688-.828.906-1.375c.625-1.578.485-5.328.485-7.078s.14-5.5-.485-7.078c-.218-.547-.484-.953-.906-1.375s-.828-.688-1.375-.906C17.5 4.016 13.75 4.156 12 4.156zM24 14c0 1.656.016 3.297-.078 4.953-.094 1.922-.531 3.625-1.938 5.031s-3.109 1.844-5.03 1.938C15.296 26.016 13.655 26 12 26s-3.297.016-4.953-.078c-1.922-.094-3.625-.531-5.031-1.938S.172 20.875.078 18.954C-.016 17.296 0 15.655 0 14s-.016-3.297.078-4.953C.172 7.125.61 5.422 2.016 4.016s3.109-1.844 5.03-1.938C8.704 1.984 10.345 2 12 2s3.297-.016 4.953.078c1.922.094 3.625.531 5.031 1.938s1.844 3.109 1.938 5.03C24.016 10.704 24 12.345 24 14z","fill":"inherit"}})])
          )
        }
      }
    